import { Box, Button } from '../../widgets'
import { QuestionOrder, Toolbar } from './'
import { useView } from '@10000/react'

export const SquizButton = ({ text, mobileText, onClick, disabled, hideTools, ...props }) => {
  const { options: { solo } = {} } = useView('squiz')

  return (
    <Box fullWidth gap={!hideTools && 16}>
      {(!hideTools && !solo) &&
        <Box className="mobile-only" justifyContent="center" alignItems="center">
          <Toolbar mobileOnly />
        </Box>
      }
      <Button className={mobileText && 'desktop-only'} fullWidth onClick={onClick} disabled={disabled} {...props}>
        {text}
      </Button>
      {mobileText && (
        <Button className="mobile-only" fullWidth onClick={onClick} disabled={disabled} {...props}>
          {mobileText}
        </Button>
      )}
      {!hideTools &&
        <Box justifyContent="center" alignItems="center">
          <QuestionOrder />
        </Box>
      }
    </Box>
  )
}